import Dermo from "..";

const routes = [
    { name: "DermaVisitaList", path: "/paziente/dermatologia/visitadermatologica", component: Dermo.VisitaDermatologica.DermaVisitaList, meta: { title: "Visita Dermatologica" } },
    { name: "DermaVisitaEdit", path: "/paziente/dermatologia/visitadermatologica/edit/:id", component: Dermo.VisitaDermatologica.DermaVisitaEdit, meta: { title: "Visita Dermatologica" } },
    { name: "DermaVisitaView", path: "/paziente/dermatologia/visitadermatologica/view/:id", component: Dermo.VisitaDermatologica.DermaVisitaView, meta: { title: "Visita Dermatologica" } },
];

export default routes;